export default __webpack_public_path__ + "static/media/calendar-small-b.fefc4b7a.svg";